import request from '@/utils/request'

interface ApiCategory {
  id: number
  language_id: number | null
  name: string | null
  visible: number | null
  image: string | null
  children?: ApiCategory[]
}
export const uploadCategoryChanges = formData =>
  request({
    url: '/categories',
    method: 'post',
    data: formData,
    timeout: 45 * 1000
  })
export const getCategories = () =>
  request({
    url: '/categories',
    method: 'get',
    timeout: 6 * 1000
  })
export const removeCategory = id =>
  request({
    url: '/categories',
    method: 'delete',
    data: id,
    timeout: 10 * 1000
  })
